import { FeaturedHero } from '@testifysec/wings';
import { graphql } from 'gatsby';
import React from 'react';
import serializeLexicalRichText from '../utils/serializeLexicalRichText';
import './richTextStyles.css';
import { SEO } from '../components/SEO/SEO';
import { BlogTemplateProps } from './blog-types';
import { Image } from '../components/Image';

export function Head({ data }: BlogTemplateProps) {
  const articleData = data.allPayloadBlogArticles.nodes[0];
  return (
    <SEO title={articleData.title} author={articleData.author?.name} image={articleData.image?.url}>
      <script src="https://webforms.pipedrive.com/f/loader" async></script>
      <script id="vtag-ai-js" async src="https://r2.leadsy.ai/tag.js" data-pid="1E4hE9CsUOnARPuXs" data-version="062024"></script>
    </SEO>
  );
}

export default function BlogTemplate({ data }: BlogTemplateProps) {
  const articleData = data.allPayloadBlogArticles.nodes[0];

  articleData.content = JSON.parse(articleData.contentString);

  return (
    <div className="blog-post">
      <div className="">
        <FeaturedHero
          h1={articleData.title}
          p={`Author: ${articleData.author?.name}`}
          small={`${new Date(articleData.creationDate).toLocaleDateString()}`}
          image={{ src: articleData.image?.url, alt: articleData.image?.alt }}
          imageClassName={articleData.imageClassName}
          imageComponentType={Image}
        />
      </div>

      <div className=" container-x container-y md:max-w-2xl">
        <div className="richText">{serializeLexicalRichText(articleData.content.root)}</div>
      </div>
    </div>
  );
}

export const query = graphql`
  query BlogArticle($slug: String) {
    allPayloadBlogArticles(filter: { slug: { eq: $slug } }) {
      nodes {
        id
        title
        slug
        creationDate
        author {
          name
        }
        image {
          alt
          url
        }
        contentString
        imageClassName
      }
    }
  }
`;
